var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 15.5339C2.16218 15.5339 1.73043 15.3542 1.37109 14.9949C1.01176 14.6355 0.832398 14.2041 0.833009 13.7005V2.70052C0.833009 2.19636 1.01268 1.76461 1.37201 1.40527C1.73134 1.04594 2.16279 0.866578 2.66634 0.867189H8.16634L9.99968 2.70052H17.333C17.8372 2.70052 18.2689 2.88019 18.6283 3.23952C18.9876 3.59886 19.167 4.0303 19.1663 4.53386H2.66634V13.7005L4.86634 6.36719H20.5413L18.1809 14.2276C18.0587 14.6248 17.8332 14.942 17.5044 15.1791C17.1756 15.4162 16.813 15.5345 16.4163 15.5339H2.66634Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeFolder);
export default __webpack_public_path__ + "static/media/type-folder.167246bf1fcd25dcc39e9ba32cd4e533.svg";
export { ForwardRef as ReactComponent };